exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mobile-wrapper .content-wrapper{overflow-y:auto;overflow-x:hidden}.mobile-wrapper .content-wrapper .switch-company-notify{position:relative;text-align:center;width:100vw;height:100vh}.mobile-wrapper .content-wrapper .switch-company-notify .switch-company-notify-image{position:absolute;top:18px;left:calc(50% - 100px);width:200px}.mobile-wrapper .content-wrapper .switch-company-notify .switch-company-notify-instructions{position:absolute;width:100%;bottom:80px}.mobile-wrapper .content-wrapper .switch-company-notify .switch-company-notify-instructions .switch-company-notify-text{font-family:Oswald,sans-serif;font-size:20px;color:#184e78}.mobile-wrapper .content-wrapper .switch-company-notify .switch-company-notify-instructions .switch-company-notify-text-2{display:flex;justify-content:center}.mobile-wrapper .content-wrapper .switch-company-notify .switch-company-notify-instructions .switch-company-dashboard-icon{margin-left:5px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/mobileWrappers/SwitchCompanyWrapper/SwitchCompanyWrapper.scss
// module id = 1875
// module chunks = 0